module.exports = require('../_components/@alicd/next-table/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/table/index.js
// module id = 275
// module chunks = 0